// **** import modules ****
import $ from "jquery";

// local modules
import app, { csl } from "@@assets/scripts/app";
import vuwer from "@@assets/scripts/vuwer";


// **** process ****
vuwer
.add("siteFooter", {
	selector: "#site_footer",
	
	onReady($self) {
		if(!$self) {
			csl.log.grey("no siteFooter.");
			return false;
		}
		
		$self.find("a").each((i, elm) => {
			if(elm.href === app.URL) {
				$(elm).addClass("is-current");
			}
		});
		
		// ネットショップへのリンクを最下部にコピー
		const $goNetShop = $self.find('.nav-item[data-content="netshop"]');
		if($goNetShop.length) {
			$("<div/>").addClass($goNetShop.get(0).className).attr({
				"data-content": $goNetShop.attr("data-content")
			}).html( $goNetShop.html() ).appendTo($self);
		}
	}
});
